import React, { useState, useEffect, useRef } from 'react';
import './BlogComponent.css';
import adventureImg from '../../assets/Adventure vs. Leisure_ Choosing Your Perfect Vacation.png'
import { useParams } from "react-router-dom";
import { blogPosts } from "../../common/data";
import Nav from '../../common/Nav';
import Footer from '../../common/Footer';
const BlogComponent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const blogRef = useRef(null);
    const { slug } = useParams();
  const blog = blogPosts.find((post) => post.slug === slug);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    if (blogRef.current) {
      observer.observe(blogRef.current);
    }

    return () => {
      if (blogRef.current) {
        observer.unobserve(blogRef.current);
      }
    };
  }, []);

  return (
    <div>
    <div className="blog-container" ref={blogRef}>
      <Nav/>
      <div className="blog-image-container my-20">
        <img 
          src={adventureImg} 
          alt="Adventure vs Leisure travel" 
          className="blog-main-image"
          loading="lazy"
        />
      </div>
      
      <div className={`blog-content ${isVisible ? 'visible' : ''}`}>
        <h1>Adventure vs. Leisure: Choosing Your Perfect Vacation</h1>
        <p className="meta-description">Adventure or leisure? Discover the perfect vacation for you. Plan stress-free with a registered travel agent in Delhi. Find the best travel agency for international tours.</p>
        
        <p>Planning a vacation comes with one big question—should you go for an adrenaline-filled adventure or a relaxing leisure trip? Both types of vacations offer unique experiences, catering to different personalities, moods, and travel goals. Whether you dream of hiking rugged mountains or unwinding by the beach, your choice will shape your travel memories.</p>
        
        <h2>The Thrill of Adventure Travel</h2>
        <p>Adventure travel is for those who seek excitement and love to push their limits. It often includes physically demanding activities such as trekking, scuba diving, paragliding, or wildlife safaris. These experiences provide an unmatched sense of accomplishment and an opportunity to explore breathtaking landscapes.</p>
        
        <h3>Why Choose an Adventure Vacation?</h3>
        <ul>
          <li><strong>Adrenaline Rush</strong> – Activities like skydiving, white-water rafting, and bungee jumping create unforgettable moments.</li>
          <li><strong>Personal Growth</strong> – Overcoming challenges, whether climbing a peak or diving into the ocean, builds resilience and confidence.</li>
          <li><strong>Unique Cultural Exposure</strong> – Adventure trips often lead to remote locations, offering deeper insights into local traditions and lifestyles.</li>
        </ul>
        
        <h3>Popular Adventure Destinations</h3>
        <ul>
          <li><strong>Rishikesh, India</strong> – Perfect for river rafting, cliff jumping, and bungee jumping.</li>
          <li><strong>Leh-Ladakh</strong> – Offers thrilling road trips, treks, and biking adventures.</li>
          <li><strong>Switzerland</strong> – Known for skiing, paragliding, and hiking in the Alps.</li>
          <li><strong>New Zealand</strong> – A paradise for extreme sports like skydiving and canyoning.</li>
        </ul>
        
        <h2>The Charm of Leisure Travel</h2>
        <p>Leisure vacations are designed for relaxation and rejuvenation. These trips focus on comfort, slow-paced exploration, and unwinding at scenic locations. Whether it's a beach retreat, a cultural city tour, or a luxury resort stay, leisure travel is all about indulgence.</p>
        
        <h3>Why Choose a Leisure Vacation?</h3>
        <ul>
          <li><strong>Stress-Free Experience</strong> – No rigid itineraries, just peaceful sightseeing and relaxation.</li>
          <li><strong>Rejuvenation</strong> – Ideal for unwinding at spas, beaches, or cozy mountain resorts.</li>
          <li><strong>Quality Time</strong> – Perfect for family vacations, romantic getaways, or solo retreats.</li>
        </ul>
        
        <h3>Popular Leisure Destinations</h3>
        <ul>
          <li><strong>Maldives</strong> – Overwater villas, white sandy beaches, and clear blue waters.</li>
          <li><strong>Paris, France</strong> – A dream city with art, history, and luxury shopping.</li>
          <li><strong>Goa, India</strong> – Laid-back beaches, delicious seafood, and vibrant nightlife.</li>
          <li><strong>Bali, Indonesia</strong> – Serene landscapes, yoga retreats, and cultural sites.</li>
        </ul>
        
        <h2>Finding the Right Balance</h2>
        <p>Sometimes, the best vacation combines elements of both adventure and leisure. Destinations like Thailand, Spain, and Australia offer thrilling activities alongside relaxing experiences. Choosing a balanced itinerary allows you to explore exciting adventures while enjoying moments of peace.</p>
        
        <h2>Planning Your Ideal Trip with Expert Help</h2>
        <p>Choosing between an adventure and leisure vacation can be overwhelming, but a professional travel agency simplifies the process. If you're searching for the Top 10 travel agency in Delhi or need recommendations from the Delhi travel agency list, it's essential to pick one that understands your travel needs.</p>
        <p>A registered travel agent in Delhi, such as Pravasa.in, ensures a hassle-free experience by offering customized itineraries, the best deals, and seamless booking services. Whether you need a travel agency in Delhi near me for last-minute planning or the best travel agency in Delhi, expert guidance helps make your dream vacation a reality.</p>
        
        <h2>Conclusion</h2>
        <p>Adventure and leisure travel cater to different preferences, but both offer enriching experiences. While thrill-seekers enjoy heart-pounding activities, relaxation lovers cherish peaceful getaways. With the right travel partner like Pravasa.in, you can craft a vacation that perfectly suits your style—whether it's an action-packed journey or a tranquil retreat.</p>
      </div>
     
    </div>
    <Footer/>
    </div>
  );
};

export default BlogComponent;


// import React, { useState, useEffect } from 'react';
// import './BlogComponent.css';

// const BlogComponent = ({ blogs }) => {
//   const [visibleBlogIndex, setVisibleBlogIndex] = useState(0);
//   const [isScrollingUp, setIsScrollingUp] = useState(false);
//   const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollPos = window.pageYOffset;
//       setIsScrollingUp(currentScrollPos < prevScrollPos && prevScrollPos - currentScrollPos > 5);
//       setPrevScrollPos(currentScrollPos);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [prevScrollPos]);

//   useEffect(() => {
//     if (isScrollingUp && visibleBlogIndex < blogs.length - 1) {
//       const timer = setTimeout(() => {
//         setVisibleBlogIndex(visibleBlogIndex + 1);
//       }, 300);
//       return () => clearTimeout(timer);
//     }
//   }, [isScrollingUp, visibleBlogIndex, blogs.length]);

//   return (
//     <div className="blog-container">
//       {blogs.map((blog, index) => (
//         <div 
//           key={index} 
//           className={`blog-post ${index <= visibleBlogIndex ? 'visible' : ''}`}
//         >
//           <div className="blog-image-container">
//             <img 
//               src={blog.imageUrl} 
//               alt={blog.title} 
//               className="blog-image" 
//               loading="lazy"
//             />
//           </div>
          
//           {index <= visibleBlogIndex && (
//             <div className="blog-content">
//               <h1 className="blog-title">{blog.title}</h1>
//               <p className="blog-meta">{blog.metaDescription}</p>
//               <div className="blog-text">
//                 {blog.content.map((paragraph, pIndex) => (
//                   <p key={pIndex}>{paragraph}</p>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// // Default props with your provided blog data
// BlogComponent.defaultProps = {
//   blogs: [
//     {
//       title: "Adventure vs. Leisure: Choosing Your Perfect Vacation",
//       metaDescription: "Adventure or leisure? Discover the perfect vacation for you. Plan stress-free with a registered travel agent in Delhi. Find the best travel agency for international tours.",
//       imageUrl: "https://images.unsplash.com/photo-1506929562872-bb421503ef21?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
//       content: [
//         "Planning a vacation comes with one big question—should you go for an adrenaline-filled adventure or a relaxing leisure trip? Both types of vacations offer unique experiences, catering to different personalities, moods, and travel goals. Whether you dream of hiking rugged mountains or unwinding by the beach, your choice will shape your travel memories.",
//         "The Thrill of Adventure Travel Adventure travel is for those who seek excitement and love to push their limits. It often includes physically demanding activities such as trekking, scuba diving, paragliding, or wildlife safaris. These experiences provide an unmatched sense of accomplishment and an opportunity to explore breathtaking landscapes.",
//         "Why Choose an Adventure Vacation? Adrenaline Rush – Activities like skydiving, white-water rafting, and bungee jumping create unforgettable moments. Personal Growth – Overcoming challenges, whether climbing a peak or diving into the ocean, builds resilience and confidence. Unique Cultural Exposure – Adventure trips often lead to remote locations, offering deeper insights into local traditions and lifestyles.",
//         "Popular Adventure Destinations Rishikesh, India – Perfect for river rafting, cliff jumping, and bungee jumping. Leh-Ladakh – Offers thrilling road trips, treks, and biking adventures. Switzerland – Known for skiing, paragliding, and hiking in the Alps. New Zealand – A paradise for extreme sports like skydiving and canyoning.",
//         "The Charm of Leisure Travel Leisure vacations are designed for relaxation and rejuvenation. These trips focus on comfort, slow-paced exploration, and unwinding at scenic locations. Whether it's a beach retreat, a cultural city tour, or a luxury resort stay, leisure travel is all about indulgence.",
//         "Why Choose a Leisure Vacation? Stress-Free Experience – No rigid itineraries, just peaceful sightseeing and relaxation. Rejuvenation – Ideal for unwinding at spas, beaches, or cozy mountain resorts. Quality Time – Perfect for family vacations, romantic getaways, or solo retreats.",
//         "Popular Leisure Destinations Maldives – Overwater villas, white sandy beaches, and clear blue waters. Paris, France – A dream city with art, history, and luxury shopping. Goa, India – Laid-back beaches, delicious seafood, and vibrant nightlife. Bali, Indonesia – Serene landscapes, yoga retreats, and cultural sites.",
//         "Finding the Right Balance Sometimes, the best vacation combines elements of both adventure and leisure. Destinations like Thailand, Spain, and Australia offer thrilling activities alongside relaxing experiences. Choosing a balanced itinerary allows you to explore exciting adventures while enjoying moments of peace.",
//         "Planning Your Ideal Trip with Expert Help Choosing between an adventure and leisure vacation can be overwhelming, but a professional travel agency simplifies the process. If you're searching for the Top 10 travel agency in Delhi or need recommendations from the Delhi travel agency list, it's essential to pick one that understands your travel needs.",
//         "A registered travel agent in Delhi, such as Pravasa.in, ensures a hassle-free experience by offering customized itineraries, the best deals, and seamless booking services. Whether you need a travel agency in Delhi near me for last-minute planning or the best travel agency in Delhi, expert guidance helps make your dream vacation a reality.",
//         "Conclusion Adventure and leisure travel cater to different preferences, but both offer enriching experiences. While thrill-seekers enjoy heart-pounding activities, relaxation lovers cherish peaceful getaways. With the right travel partner like Pravasa.in, you can craft a vacation that perfectly suits your style—whether it's an action-packed journey or a tranquil retreat."
//       ]
//     }
//   ]
// };

// export default BlogComponent;
// import { useParams } from "react-router-dom";
// import { blogPosts } from "../../common/data";


// const BlogComponent = () => {
//   const { slug } = useParams();
//   const blog = blogPosts.find((post) => post.slug === slug);

//   if (!blog) return <div className="p-4">Blog not found.</div>;

//   return (
//     <div className="max-w-4xl mx-auto p-6">
//       <img src={blog.thumbnail} alt={blog.title} className="w-full h-64 object-cover rounded-xl mb-4" />
//       <h1 className="text-3xl font-bold mb-2">{blog.title}</h1>
//       <p className="text-sm text-gray-500 mb-4">{blog.metaDescription}</p>
//       <div className="text-lg leading-relaxed whitespace-pre-line">{blog.content}</div>
//     </div>
//   );
// };

// export default BlogComponent;
